import {useMemo} from 'react'

export interface ChronicleCommand {
  key: string
  displayKey?: string
  description: string
  appendSpace?: boolean
}

const CHRONICLE_COMMAND: ChronicleCommand = {
  key: '/chronicle',
  description: 'View session history and activity',
  appendSpace: true,
}

const CHRONICLE_OPTIONS = [
  {key: 'standup', description: 'Get a report on your work from the last day'},
  {key: 'search', description: 'Search all session content by keyword or topic'},
  {key: 'tips', description: 'Get personalized tips based on usage patterns'},
  {
    key: 'cost-tips',
    description: 'Get personalized tips to reduce token usage and cost',
  },
  {
    key: 'improve',
    description: 'Suggest improvements to copilot-instructions.md',
  },
]

/**
 * Returns chronicle commands that match the current input text as a prefix.
 */
export function useChronicleAutocomplete(currentText: string, grouped = false) {
  const suggestions = useMemo(() => {
    const trimmed = currentText.trimStart()
    if (!trimmed || trimmed.length < 1) return []

    if (grouped) {
      if (CHRONICLE_COMMAND.key.startsWith(trimmed)) return [CHRONICLE_COMMAND]
      if (!trimmed.startsWith(`${CHRONICLE_COMMAND.key} `)) return []
    }

    return CHRONICLE_OPTIONS.map(option => ({
      key: `${CHRONICLE_COMMAND.key} ${option.key}`,
      ...(grouped ? {displayKey: option.key} : {}),
      description: option.description,
    })).filter(command => command.key.startsWith(trimmed) && command.key !== trimmed)
  }, [currentText, grouped])

  return suggestions
}
